export default __webpack_public_path__ + "static/media/athensgate.d47dc13b.md";